import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import styles from './labeled-text.styl'

const LabeledText = ({ intlKey, label, value, multiLine, warningValue }) => (
  <div className={styles.wrapper}>
    {intlKey
      ? <FormattedMessage
          id={intlKey}
          tagName="strong"
          defaultMessage={label}
      />
      : <strong>{label}</strong>}
    :
    <span
      className={[styles.value, multiLine ? styles.multiLine : '', warningValue ? styles.warningValue : ''].join(' ')}
    >
      {value}
    </span>
  </div>
)

LabeledText.propTypes = {
  intlKey: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  multiLine: PropTypes.bool,
  warningValue: PropTypes.bool,
}
LabeledText.displayName = 'LabeledText'

export default LabeledText
